import { FeedbackStatus } from 'donor/portal/pages/FeedbackDashboard/api';

export interface DonationVisualProps {
  color: string;
  amount: number;
  year: string | undefined;
  status: FeedbackStatus | undefined;
  reportId: number | undefined;
  programName: string | undefined;
}

const interpolateColor = (
  color1: number[],
  color2: number[],
  factor: number,
): number[] => {
  const result: number[] = [];
  for (let i = 0; i < 3; i++) {
    result.push(Math.round(color1[i] + factor * (color2[i] - color1[i])));
  }
  return result;
};

const hexToRgb = (hex: string): number[] => {
  const bigint = parseInt(hex.slice(1), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

const rgbToHex = (rgb: number[]): string => {
  return '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('');
};

export const generateColorShades = (
  hexColors: string[],
  numColors: number,
): string[] => {
  const rgbColors = hexColors.map(hexToRgb);
  const result: string[] = [];
  for (let i = 0; i < numColors; i++) {
    const factor = i / (numColors - 1);
    const interpolatedColor = interpolateColor(
      rgbColors[0],
      rgbColors[1],
      factor,
    );
    result.push(rgbToHex(interpolatedColor));
  }
  return result;
};
